import { useState, useEffect } from 'react'

import * as commentsApi from 'services/comments'
import errorLogging from 'services/error-logging'

function useCommentsCount(topicId?: string) {
  const [count, setCount] = useState<number | undefined>()

  useEffect(() => {
    async function fetch(topicId: string) {
      try {
        const result = await commentsApi.fetchCommentsCount(topicId)

        setCount(result)
      } catch (error) {
        errorLogging(new Error('error fetching comments count'), {
          error,
        })
      }
    }

    if (topicId) {
      fetch(topicId)
    }
  }, [topicId])

  return count
}

export default useCommentsCount
